import { Heading, Text, Stack } from '@leroy-merlin-br/backyard-react-ui'

import { Notification } from 'checkout/components/Notification'

import * as S from './styled'
import { Product } from './components'

const AssociatedProducts = ({
  onAddToCartClick,
  onProductNameClick,
  hasError,
  products,
  title
}) => {
  if (!products.length) return null

  return (
    <Stack spacing="kilo">
      <Heading as="h2" size="kilo" noMargin>{title}</Heading>

      { hasError && <S.AnimateNotification>
        <Notification type="danger">
          <Text size="kilo" noMargin>Tivemos um erro ao adicionar o produto, mas você pode tentar novamente.</Text>
        </Notification>
      </S.AnimateNotification>
      }

      <S.StackBordered spacing="kilo">
        {
          products.map((product, index) => (
            <Product
              key={product.id}
              {...product}
              onAddToCartClick={() => onAddToCartClick(product, index)}
              onProductNameClick={event => onProductNameClick(event, product, index)}
            />
          ))
        }
      </S.StackBordered>
    </Stack>
  )
}

export default AssociatedProducts
